/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SunshineInternalDtoAdminUsersUserRole,
    SunshineInternalDtoAdminUsersUserRoleFromJSON,
    SunshineInternalDtoAdminUsersUserRoleFromJSONTyped,
    SunshineInternalDtoAdminUsersUserRoleToJSON,
} from './SunshineInternalDtoAdminUsersUserRole';

/**
 * 
 * @export
 * @interface AdminUser
 */
export interface AdminUser {
    /**
     * 
     * @type {string}
     * @memberof AdminUser
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUser
     */
    firstName: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUser
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUser
     */
    lastName: string;
    /**
     * 
     * @type {SunshineInternalDtoAdminUsersUserRole}
     * @memberof AdminUser
     */
    role: SunshineInternalDtoAdminUsersUserRole;
    /**
     * 
     * @type {string}
     * @memberof AdminUser
     */
    updateAt: string;
}



export function AdminUserFromJSON(json: any): AdminUser {
    return AdminUserFromJSONTyped(json, false);
}

export function AdminUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'email': json['email'],
        'firstName': json['firstName'],
        'id': json['id'],
        'lastName': json['lastName'],
        'role': SunshineInternalDtoAdminUsersUserRoleFromJSON(json['role']),
        'updateAt': json['updateAt'],
    };
}

export function AdminUserToJSON(value?: AdminUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'email': value.email,
        'firstName': value.firstName,
        'id': value.id,
        'lastName': value.lastName,
        'role': SunshineInternalDtoAdminUsersUserRoleToJSON(value.role),
        'updateAt': value.updateAt,
    };
}

